/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-14T17:27:30.637
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentPurchaseOrderDetailed,
	listRentPurchaseOrderDetailedInit,
	listRentPurchaseOrderDetailedByAuthorizations,
	deleteRentPurchaseOrderDetailed
} from '@api/rentmanage/RentPurchaseOrderDetailed';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentPurchaseOrderDetailed({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPurchaseOrderDetailed(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPurchaseOrderDetailedByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPurchaseOrderDetailedByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPurchaseOrderDetailedInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPurchaseOrderDetailedInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentPurchaseOrderDetailed({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentPurchaseOrderDetailed({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
